export default {
  computed: {
    idAndName: function () {
      return this.inputName ? this.inputName.toLowerCase() : 'unnamedComponent'
    },
    cssWidth: function () {
      return this.width ? this.width : '300px'
    }
  }
}
